import { ResidenceOwnership, ResidenceProperty } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { AddressSchema } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/schemas/AddressSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredPastDate, requiredString } from '@/utils/zodUtils';

export const MainResidenceFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      ownershipType: requiredEnum(ResidenceOwnership, t),
      propertyType: z.nativeEnum(ResidenceProperty).optional().nullable(),
      homeExpenses: requiredString(t),
      entranceDate: requiredPastDate(t),
      mortgage: z.string().optional().nullable(),
      mainResidenceAddress: AddressSchema(t),
    })
    .refine((data) => !(data.ownershipType === ResidenceOwnership.OWNERSHIP && !data.propertyType), {
      message: t('REQUIRED_FIELD'),
      path: ['propertyType'],
    })
    .refine((data) => !(data.ownershipType === ResidenceOwnership.OWNERSHIP && !data.mortgage), {
      message: t('REQUIRED_FIELD'),
      path: ['mortgage'],
    })
    .refine((data) => data.homeExpenses && Number(data.homeExpenses) > 0, {
      message: t('HOME_EXPENSES_MUST_BE_GREATER_THAN_0'),
      path: ['homeExpenses'],
    });

export type MainResidenceFormType = z.infer<ReturnType<typeof MainResidenceFormSchema>>;
